export function getInvoicePaymentStatusTagColor(paymentId) {
  return {
    text: paymentId ? 'PAID' : 'UN-PAID',
    color: paymentId ? '#20c997' : '#dc3545',
  };
}
export function getInvoiceEmailSentStatusTagColor(emailedStatus) {
  return {
    text: emailedStatus ? 'SENT' : 'PENDING',
    color: emailedStatus ? '#20c997' : '#6f42c1',
  };
}
export function getInvoiceTypeText(invoiceType) {
  let text = invoiceType;
  switch (invoiceType) {
    case 'PAY_AS_YOU_GO':
      text = 'Pay As You Go';
      break;
    case 'MONTHLY':
      text = 'Monthly';
      break;

    default:
      break;
  }
  return text;
}
